export default "__VITE_ASSET__BqvLCbpu__"